import { render, staticRenderFns } from "./CustomerLogged.vue?vue&type=template&id=12287690&scoped=true&"
import script from "./CustomerLogged.vue?vue&type=script&lang=js&"
export * from "./CustomerLogged.vue?vue&type=script&lang=js&"
import style1 from "./CustomerLogged.vue?vue&type=style&index=1&id=12287690&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12287690",
  null
  
)

export default component.exports